import React from 'react';

import type { TopMessageProps } from './TopMessageComponent';

import HighlightPanel from '@helsenorge/designsystem-react/components/HighlightPanel';

import { isAuthorized } from '@helsenorge/framework-utils/hn-authorize';

import { ReplaceLinks } from '../navigator/replaceLinks';

export const RenderFormFillingInformation = ({ resources, userMetadata, openSidebar }: TopMessageProps): React.JSX.Element | null => {
  if (!isAuthorized()) return null;

  const cannotRepresentOthers =
    (userMetadata.CanOnlyBePerformedBySubject && !userMetadata.IsRepresentert) ||
    (!userMetadata.CanOnlyBePerformedBySubject && userMetadata.IsRepresentert);

  const messageKey = cannotRepresentOthers ? 'message_canNotRepresentOthers' : 'message_canRepresentOthers';
  const testId = cannotRepresentOthers ? 'top-message-is-representert' : 'top-message-not-is-representert';

  return (
    <HighlightPanel color="blueberry" testId={testId}>
      <ReplaceLinks messageText={resources[messageKey]} resources={resources} openSidebar={openSidebar} />
    </HighlightPanel>
  );
};
